import { render } from "./SimpleModal.vue?vue&type=template&id=9e6fb27c&scoped=true&ts=true"
import script from "./SimpleModal.vue?vue&type=script&lang=ts"
export * from "./SimpleModal.vue?vue&type=script&lang=ts"

import "./SimpleModal.vue?vue&type=style&index=0&id=9e6fb27c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e6fb27c"]])

export default __exports__